module.exports = __webpack_public_path__ + "img/06.0f5b76e9.jpg";